import axios from 'axios'
import store from '../store'
import router from '@/router'
import { getDomainConfig } from './domainConfig'

// 获取域名配置
const domainConfig = getDomainConfig()

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE,
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可在此处添加token等
    config.headers['x-foxivid-authorization'] = localStorage.getItem('token') ? localStorage.getItem('token') : '' // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers['client'] = domainConfig.apiParams.client
    config.headers['country-code'] = domainConfig.apiParams.countryCode
    config.headers['x-foxivid-language'] = localStorage.getItem('locale') || 'en'
    config.headers['source'] = domainConfig.apiParams.source
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if(response.data.code === 401 || response.data.code === 403) {
        store.dispatch('user/logout')
        // 避免重复导航到登录页
        if (router.currentRoute.path !== '/login') {
          router.push('/login')
        }
    }
    return response.data
  },
  error => {
    // 处理HTTP层面的401/403错误
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      store.dispatch('user/logout')
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

export default service